'use client';

import { motion } from 'framer-motion';

export default function InlineSidebar({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <motion.aside
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="my-8 p-4 border-l-4 border-gray-300 dark:border-gray-700 
                 bg-gray-50 dark:bg-gray-900 rounded-md"
    >
      {title && (
        <h4 className="mb-2 font-semibold text-gray-800 dark:text-gray-200">
          {title}
        </h4>
      )}
      <div className="text-sm text-gray-700 dark:text-gray-300">
        {children}
      </div>
    </motion.aside>
  );
}
